import {
  FETCH_SURFACES_REQUEST,
  FETCH_SURFACES_SUCCESS,
  FETCH_SURFACES_FAILURE,
  SAVE_SURFACE_REQUEST,
  SAVE_SURFACE_SUCCESS,
  SAVE_SURFACE_FAILURE,
  DELETE_SURFACE_REQUEST,
  DELETE_SURFACE_SUCCESS,
  DELETE_SURFACE_FAILURE,
} from './types';

const INITIAL_STATE = {
  surfaceList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SURFACES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SURFACES_SUCCESS:
      return {
        ...state,
        loading: false,
        surfaceList: action.payload,
      };

    case FETCH_SURFACES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        surfaceList: [],
      };
    case SAVE_SURFACE_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_SURFACE_SUCCESS:
      return {
        ...state,
      };

    case SAVE_SURFACE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_SURFACE_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_SURFACE_SUCCESS:
      return {
        ...state,
      };

    case DELETE_SURFACE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
